import { render } from "./LazyWysiwygEditor.vue?vue&type=template&id=3116c9dd&scoped=true"
import script from "./LazyWysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./LazyWysiwygEditor.vue?vue&type=script&lang=ts"

import "./LazyWysiwygEditor.vue?vue&type=style&index=0&id=3116c9dd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3116c9dd"

export default script